/**
 * Created by luis on 26/05/17.
 */

'use strict';

class User {
  static get ROLE() {
    return {
      SUPER_ADMIN: 'super_admin',
      INSTANCE_ADMIN: 'instance_admin',
      ADMIN: 'admin',
      USER: 'user',
    };
  }

  static get ROLES() {
    return Object.values(User.ROLE);
  }

  static get TYPE() {
    return {
      COLLABORATOR: 'collaborator', // co-worker
      CUSTOMER: 'customer', // client
      LEAD: 'lead',
      RECOMMENDATION: 'recommendation',
      VISITOR: 'visitor',
    };
  }

  static get TYPES() {
    return Object.values(User.TYPE);
  }

  static formatUserName(user) {
    if (user.firstName != null && user.lastName != null && user.firstName && user.lastName) {
      return `${user.firstName} ${user.lastName}`;
    }
    return user.username;
  }
}

module.exports = User;
